import React, { useId } from "react";
import MuiModal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import ModalHeader from "./ModalHeader";
import useStyles from "./modalStyles";
import ModalTitleContext from "./ModalTitleContext";

const Modal = ({
  open,
  onClose,
  children,
  type,
  ariaLabel,
  closeLabel,
  size = "small",
  hideIcon = false,
}) => {
  const styles = useStyles();
  const titleId = useId();

  return (
    <MuiModal open={open} onClose={onClose}>
      <Box
        className={styles.modalContainer}
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel}
        aria-labelledby={ariaLabel ? undefined : titleId}
        tabIndex={-1}
        sx={{ width: size === "large" ? 960 : 480 }}
      >
        <ModalHeader
          onClose={onClose}
          type={type}
          closeLabel={closeLabel}
          hideIcon={hideIcon}
        />
        <ModalTitleContext.Provider value={titleId}>
          <Box className={styles.contentContainer}>{children}</Box>
        </ModalTitleContext.Provider>
      </Box>
    </MuiModal>
  );
};

Modal.propTypes = {};

export default Modal;
